import React from "react";
import { Car } from "phosphor-react";
import Select from "../Inputs/Select";
import Loading from "../Loading/Loading";

export function ModelSelect({
  models,
  setModel,
  setPrepopulateItem,
  model,
  isFetchingModels,
  validate,
}) {
  return (
    <Select
      options={models?.map((m) => ({ option: m.model, info: `${m?.transmission} ${m?.fuel} ${m?.crM_ID}` }))}
      defaultValue={
        !models || models?.length === 0
          ? "No models"
          : `Select (${models?.length})`
      }
      handleChange={(value) => {
        setModel(value);
        setPrepopulateItem(models?.find((m) => m.model === value));
      }}
      value={model}
      prefix={
        isFetchingModels ? (
          <Loading />
        ) : (
          <Car size={14} weight="regular" color="var(--carter-secondary)" />
        )
      }
      label="Model*"
      id="model"
      validate={validate}
    />
  );
}
